"use client";
'use strict';

var React = require('react');
var ConfigProvider = require('../providers/ConfigProvider.js');

/**
 * React hook that help checking user device
 *
 * @example
 * ```javascript
 * const config = useConfig()
 * ```
 */
function useConfig() {
    return React.useContext(ConfigProvider.ConfigContext);
}

exports.useConfig = useConfig;
//# sourceMappingURL=useConfig.js.map
